export default __webpack_public_path__ + "static/media/6h.850a1031.png";